module.exports = "./img/2ba7a2419cf6f26c42af4cb8d5a258c4.jpg";